import { FC, useEffect, useState } from "react";

import classes from "./VotesHeader.module.css";
import { getLang, i18n } from "../../i18n";

interface Props {
  expertRate: number;
}

const VotesHeader: FC<Props> = ({ expertRate }) => {
  const lang = getLang();
  const t = i18n.votesHeader[lang];

  const [sticky, setSticky] = useState(false);
  const handleScroll = () => {
    setSticky(document.documentElement.scrollTop >= 44);
  };
  useEffect(() => {
    console.log("vote header use effect");
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={`${classes.sectionHeader} ${sticky ? classes.sticky : ""}`}
      >
        <div className={classes.headerTop}>
          <h1>{t.title}</h1>
        </div>

        {expertRate > 0 && (
          <div className={classes.winrate}>
            <div className={classes.label}>{t.expertRateLabel}</div>
            <div className={classes.value}>
              {(expertRate * 100).toFixed(0)}%
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default VotesHeader;
